import axios from 'utils/axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import _ from 'lodash';

const urls = {
  createReport: '/report',
  getAllReports: '/report/getAll',
  createNewNotes: '/report/createNotes',
  createReportStatus: '/report/updateReportStatus',
  getAllOfferReports: '/offer/getUserImpression'
};

export const createReportApi = createAsyncThunk('serviceplug/createReportApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.createReport}`,
      method: 'post',
      data: params
    });
    const data = await response.data;
    return data?.result;
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const getAllReportApi = createAsyncThunk('serviceplug/getAllReportApi', async (params, thunkApi) => {
  try {
    const response = await axios.get(urls.getAllReports, { params });
    if (response.data?.result) {
      return response.data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const getReportDetailsApi = createAsyncThunk('serviceplug/getReportDetailsApi', async (params, thunkApi) => {
  try {
    const response = await axios.get(`${urls.createReport}/${params.reportId}`);
    if (response.data?.result) {
      return response.data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const createNewNotesApi = createAsyncThunk('serviceplug/createNewNotesApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.createNewNotes}`,
      method: 'post',
      data: params
    });
    const data = await response.data;
    return data?.result;
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const createReportStatusApi = createAsyncThunk('serviceplug/createReportStatusApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.createReportStatus}`,
      method: 'put',
      data: params
    });
    const data = await response.data;
    return data?.result;
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const getAllOfferReportApi = createAsyncThunk('serviceplug/getAllOfferReportApi', async (params, thunkApi) => {
  try {
    const response = await axios.get(urls.getAllOfferReports);
    if (response.data?.result) {
      return response.data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});
